
import { Component, namespace, Vue } from 'nuxt-property-decorator'
import GoogleRating from '~/components/widgets/GoogleRating.vue'
import PhoneNumberLink from '~/components/snippets/PhoneNumberLink.vue'
import { namespace as offerStore, OfferState } from '~/store/modules/Offer'
import { getExternalIndexHref } from '~/utils/external-links.utils'

const OfferStore = namespace(offerStore)

@Component({
  components: {
    GoogleRating,
    PhoneNumberLink,
  },
})
export default class PartnerFooter extends Vue {
  private readonly currentYear = (new Date()).getFullYear()

  @OfferStore.Getter('partnersList') partnersList!: OfferState['providersList']

  get externalIndexHref (): string {
    return getExternalIndexHref(this.$config.BASE_URL, this.localePath)
  }
}
